import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from '../../common/withRouter';
import { ButtonOBSOLETED, Notification, Message } from '../../web.common';
import PageTop from '../layout/PageTop';
import withApi from '../higherOrderComponents/withApi';

const PlayPlayersInternal = (props) => {
  const [notification, setNotification] = useState(null);
  const [busy, setBusy] = useState(false);

  const handleDownload = async () => {
    setBusy(true);
    setNotification(null);
    try {
      await props.api.playReport.downloadCsv();
      setNotification(new Message('success', 'CSV downloaded'));
    } catch (e) {
      setNotification(new Message('error', `Download failed: ${e?.message || 'unknown error'}`));
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <Notification newMessage={notification} />
      <PageTop
        documentTitle='PLAY players'
        documentDescription='Export of all PLAY users with full profile data'
        mainHeadingContent='PLAY players'
      />

      <div style={{ padding: 16, maxWidth: 720 }}>
        <p style={{ color: '#444', lineHeight: 1.5 }}>
          Download a CSV of every PLAY profile in the database, including:
        </p>
        <ul style={{ color: '#555', lineHeight: 1.6 }}>
          <li>User: id, name, email, phone, active status</li>
          <li>Profile: birth year, gender, expat / tourist / partner description</li>
          <li>Sports (with level &amp; description), availability slots</li>
          <li>Affiliations grouped by Education / Workplace / Club / Neighborhood</li>
          <li>Ambassador roles (affiliation / sport / status)</li>
          <li>Dismissed banners (key + dismiss count)</li>
          <li>Invites sent count, venue count, timestamps</li>
        </ul>

        <div style={{ marginTop: 24 }}>
          <ButtonOBSOLETED
            onClick={handleDownload}
            disabled={busy}
            buttonContent={busy ? 'Downloading…' : 'Download CSV'}
          />
        </div>
      </div>
    </>
  );
};

PlayPlayersInternal.propTypes = {
  api: PropTypes.object.isRequired,
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(withRouter(withApi(PlayPlayersInternal)));
